import SelectFCAndChannelForm from './SelectFCAndChannelForm'

export default SelectFCAndChannelForm
